
import { useQuery } from '@tanstack/react-query';
import { bookServiceApi } from '@/services/api';

export interface CollectionSummary {
    id: number;
    name: string;
    description: string;
    icon: string;
}

export interface CollectionBook {
    book_id: number;
    title: string;
    author: string;
    cover_image_url: string | null;
    average_rating: number;
    topic?: string;
}

export interface CollectionDetail extends CollectionSummary {
    books: CollectionBook[];
}

export const useCollections = () => {
    return useQuery({
        queryKey: ['collections'],
        queryFn: async () => {
            const response = await bookServiceApi.get<CollectionSummary[]>('/collections/');
            if (!response.success) throw new Error(response.error);
            return response.data;
        },
    });
};

export const useCollectionDetail = (id: number) => {
    return useQuery({
        queryKey: ['collection', id],
        queryFn: async () => {
            const response = await bookServiceApi.get<CollectionDetail>(`/collections/${id}`);
            if (!response.success) throw new Error(response.error);
            return response.data;
        },
        enabled: !!id,
    });
};
